import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'

import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import Image from '@segment/matcha/components/Image'
import Elevation from '@segment/matcha/components/Elevation'

export interface VideoProps {
  url: string
  cover: string
}

const Video: FC<PropsWithChildren<VideoProps>> = ({ url, cover }) => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)
  const theme = useTheme()

  return (
    <Elevation elevation={1} type="dropShadow">
      <VideoPlayerBase
        url={url}
        playing={playing}
        onPause={stop}
        onPlay={play}
        config={{
          wistia: {
            options: { playerColor: theme.palette.twilio.gray[100], playButton: false, smallPlayButton: false },
          },
        }}
      >
        {!playing && <VideoPlayer.BigPlayButton ariaLabel="Play Button" onClick={play} />}
        {!playing && (
          <VideoPlayer.Cover key="cover">
            <Picture>
              <source type="image/webp" srcSet={cover} />
              <StyledImage width="800" height="455" src={cover} alt="Illustration: Cover" loading="lazy" />
            </Picture>
          </VideoPlayer.Cover>
        )}
      </VideoPlayerBase>
    </Elevation>
  )
}

const Picture = styled.picture`
  margin: 0 auto;
`

const StyledImage = styled(Image)`
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export default Video
